import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { BrandMark } from '@/components/generals/brand-mark'
import { siteConfig } from '@/constants/site'

interface LogoProps {
    size?: 'md' | 'lg'
    className?: string
    onClick?: () => void
}

const sizes = {
    md: {
        mark: 'size-6',
        text: 'text-[1.125rem]'
    },
    lg: {
        mark: 'size-8',
        text: 'text-[1.4rem]'
    }
}

export const Logo: FC<LogoProps> = ({ size = 'md', className, onClick }): ReactNode => {
    return (
        <Link
            href='/'
            onClick={onClick}
            className={cn(
                'inline-flex shrink-0 items-center gap-2 rounded-control transition-opacity duration-300 hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary',
                className
            )}
        >
            <BrandMark className={sizes[size].mark} />

            <span
                className={cn(
                    'bg-linear-to-r from-black to-[#8a8a8a] bg-clip-text font-heading font-semibold leading-none tracking-tight whitespace-nowrap text-transparent',
                    sizes[size].text
                )}
            >
                {siteConfig.name}
            </span>
        </Link>
    )
}
